import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { EApplicationForm } from '../forms/e-application.form';
import { ReactiveFormsModule } from '@angular/forms';
import { EApplicationFormComponent } from '../components/e-application-form/e-application-form.component';

import { Store } from '@ngrx/store';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { loadUserDetails } from '../../../store/actions/user-details.actions';
import { IssueReportCommonService } from '../../../services/issue-report.common.service';
import { SessionService } from '../../../services/ssession.service';
import { AlertComponent } from '../../../common/alert/alert.component';

@Component({
  selector: 'app-e-application-create-page',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    ContentComponent,
    RouterLink,
    ReactiveFormsModule,
    EApplicationFormComponent,
    AlertComponent
  ],
  providers: [EApplicationForm, IssueReportCommonService],
  templateUrl: './e-application-create-page.component.html'
})
export class EApplicationCreatePageComponent implements OnInit {

  public pending = false;

  private store$: Store = inject(Store);

  public authed: boolean = SessionService.Authed();

  constructor(
    public form: EApplicationForm,
    private router: Router,
    private issueReportCommonService: IssueReportCommonService
  ) {
  }

  public onSubmit(): void {
    if (this.form.valid) {
      this.pending = true;
      this.issueReportCommonService.sendReport({
        ...this.form.toReport()
      }, this.form.attachments).subscribe({
        next: (report) => {
          this.pending = false;
          this.router.navigateByUrl('/zgloszenie/sukces', { state: { report } });
        },
        error: error => {
          this.pending = false;
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadUserDetails());
  }
}
